export const MERCHANDISE_CHANNEL_DETAIL_REQUESTED = "MERCHANDISE_CHANNEL_DETAIL_REQUESTED";
export const MERCHANDISE_CHANNEL_DETAIL_RECEIVED = "MERCHANDISE_CHANNEL_DETAIL_RECEIVED";
export const MERCHANDISE_CHANNEL_DETAIL_REQUEST_FAILED = "MERCHANDISE_CHANNEL_DETAIL_REQUEST_FAILED";

export const MERCHANDISE_CHANNELS_REQUESTED = "MERCHANDISE_CHANNELS_REQUESTED";
export const MERCHANDISE_CHANNELS_RECEIVED = "MERCHANDISE_CHANNELS_RECEIVED";
export const MERCHANDISE_CHANNELS_FAILED = "MERCHANDISE_CHANNELS_FAILED";

export const requestChannelVendorDetails = () => ({
  type: MERCHANDISE_CHANNELS_REQUESTED
});
export const receiveChannelVendorDetails = channels => ({
  type: MERCHANDISE_CHANNELS_RECEIVED,
  payload: channels
});

export const requestChannelDetail = vendorId => ({
  type: MERCHANDISE_CHANNEL_DETAIL_REQUESTED,
  id: vendorId
});
export const receiveChannelDetail = (vendorId, channel) => ({
  type: MERCHANDISE_CHANNEL_DETAIL_RECEIVED,
  payload: channel,
  id: vendorId
});
export const errorChannelDetail = vendorId => ({
  type: MERCHANDISE_CHANNEL_DETAIL_REQUEST_FAILED,
  id: vendorId
});
